module.exports = __webpack_public_path__ + "static/img/dj.423c4156.svg";